"use client";

import { motion } from "motion/react";
import Image from "next/image";

interface PropertyHeroProps {
  image: string;
  title?: string;
}

export function PropertyHero({ image, title }: PropertyHeroProps) {
  return (
    <div className="relative h-[60vh] md:h-[80vh] w-full overflow-hidden">
      <div className="absolute inset-0 bg-black/20 z-10" />
      <motion.div
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        className="relative h-full w-full"
      >
        <Image
          src={image}
          alt={title || "Property Image"}
          fill
          className="object-cover"
          priority
        />
      </motion.div>

      {title && (
        <div className="absolute inset-0 z-20 flex items-center justify-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="font-serif text-4xl md:text-6xl lg:text-6xl text-white text-center px-4 drop-shadow-md"
          >
            {title}
          </motion.h1>
        </div>
      )}
    </div>
  );
}
